import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public isPageRefreshed = false;

  markAsRefreshed(): void {
    this.isPageRefreshed = true;
  }

  markAsNotRefreshed(): void {
    this.isPageRefreshed = false;
  }
}